import { toast } from 'react-toastify'

export const toastErrorDisplay = (error: any) => {
  if (error?.errorDetail?.length > 0) {
    toast.error(error.errorDetail[0].message)
  } else if (error.errorTitle) {
    toast.error(error.errorTitle)
  }
}
